// extracted by mini-css-extract-plugin
export default {"content":"styles_content__SCinW","title":"styles_title__PO0eg","subtitle":"styles_subtitle__hVcSE","text":"styles_text__hfw1Y","textItem":"styles_textItem__MV317"};